import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'CampaignClass', method: 'GET', body: null, token: token })
}
